import React, {Component} from 'react';
import './App.css';
import './shared/css/theme-default/bootstrap.css'
import './shared/css/theme-default/materialadmin.css'
import './shared/css/theme-default/font-awesome.min.css'
import './shared/css/theme-default/material-design-iconic-font.min.css'
import StatContainer from "./containers/StatContainer/StatContainer";
import {BrowserRouter, Route} from "react-router-dom";
import {Switch} from "react-router";
import MenuContainer from "./containers/MenuContainer/MenuContainer";
import Widgets from "./components/Widgets";
import GroceryContainer from "./containers/GroceryContainer/GroceryContainer";
import PharmaciesTable from "./components/PharmaciesTable/PharmaciesTable";
import AppHeader from "./components/AppHeader/AppHeader";

class App extends Component {

  render() {
    return (
      <BrowserRouter>
        <div className="App">
          <AppHeader/>
          <div id="base">
            <div className="offcanvas">
            </div>
            <div id="content">
              <Switch>
                <Route path="/" exact component={StatContainer}/>
                <Route path="/stats" component={Widgets}/>
                <Route path="/pharmacies" component={PharmaciesTable}/>
                <Route path="/groceries" component={GroceryContainer}/>
              </Switch>
            </div>
            <MenuContainer/>
          </div>
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
